import { render, staticRenderFns } from "./CheckInRecordDetails.vue?vue&type=template&id=cf20c614&scoped=true"
import script from "./CheckInRecordDetails.vue?vue&type=script&lang=js"
export * from "./CheckInRecordDetails.vue?vue&type=script&lang=js"
import style0 from "./CheckInRecordDetails.vue?vue&type=style&index=0&id=cf20c614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf20c614",
  null
  
)

export default component.exports